export default __webpack_public_path__ + "static/media/icon-xbox-green.76d33f81.svg";